import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // 引入路由配置

// 引入 Element Plus 和样式
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

// 引入图标库 (因为我们在按钮里用了 <Position /> 图标)
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { createPinia } from "pinia";

const app = createApp(App);

// 全局注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(router); // 使用路由
app.use(ElementPlus);
app.use(createPinia()); // 使用 Pinia 进行状态管理
app.mount("#app");
